import styled from '@emotion/styled'
import { WorkbookDomain } from '@mathflat/domain/@entities/(Content)/Workbook/domain.ts'
import { observer } from 'mobx-react'
import { useLocation, useNavigate } from 'react-router'

import { tJosa } from '~/@app/i18n'
import { routeName } from '~/@common/constants/route'
import { useCallbackOnVisibilityChange } from '~/@common/hooks/useCallbackOnVisibilityChange'
import { useStudentAppMediaQuery } from '~/@common/hooks/useMediaQuery'
import { isWorkbookTypeAllowed } from '~/@common/models/(Permission)/permissionUtils'
import { commonRepo } from '~/@common/services/repo.service'
import { mediaQuery } from '~/@common/styles/mediaQuery'
import { SubTabTextRadioGroup } from '~/@common/ui/SubTab/SubTabGroup'
import { SubTabButtonGroupItem, SubTabTextRadioGroupItem } from '~/@common/ui/SubTab/SubTabItem'

import StudentWorkbookListWidget from './@widgets/StudentWorkbookList/StudentWorkbooklist.widget'

const StudentWorkbookListPage = () => {
  useCallbackOnVisibilityChange()

  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { isMobile } = useStudentAppMediaQuery()

  const TabComponent = isMobile
    ? SubTabTextRadioGroupItem
    : (props) => <SubTabButtonGroupItem {...props} minWidth={188} />

  return (
    <S.StudentWorkListPage>
      <div className="sub-tab">
        <SubTabTextRadioGroup
          value={pathname}
          onChange={(path) => {
            navigate(path as string)
          }}
        >
          <TabComponent value={routeName.student.generalStudentWorkbookList}>일반교재</TabComponent>
          {isWorkbookTypeAllowed(commonRepo.permission, WorkbookDomain.TYPE.커스텀시그니처교재) && (
            <TabComponent value={routeName.student.customSignatureStudentWorkbookList}>
              시그니처교재
            </TabComponent>
          )}
          {isWorkbookTypeAllowed(commonRepo.permission, WorkbookDomain.TYPE.학원그룹교재) && (
            <TabComponent value={routeName.student.academyGroupStudentWorkbookList}>
              {tJosa('학원그룹교재')}
            </TabComponent>
          )}
        </SubTabTextRadioGroup>
      </div>
      {/* 리스트 테이블 */}
      <StudentWorkbookListWidget />
    </S.StudentWorkListPage>
  )
}

export default observer(StudentWorkbookListPage)

const S = {
  StudentWorkListPage: styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: 100%;
    padding: 8px 16px 0;
    .sub-tab {
      display: flex;
      justify-content: center;
      flex: 0 0 38px;
    }
    ${mediaQuery.underTablet} {
      gap: 8px;
      .sub-tab {
        justify-content: start;
        align-items: center;
        padding-block: 10px;
      }
    }
  `,
}
